import '../styles/DashboardContinuePanel.css';
import React from 'react';

const DESTINATIONS = [
  {
    href: '/transfer',
    title: 'Transfer',
    sub: 'Move funds',
    route: '/transfer',
    arrow: '→',
  },
  {
    href: '/transfer-history',
    title: 'Transfer History',
    sub: 'Review transfers',
    route: '/transfer-history',
    arrow: '→',
  },
];

function DashboardContinuePanel() {
  return (
    <section className="dcp-root" aria-labelledby="dcp-heading">
      <div className="dcp-inner">
        <div className="dcp-panel">
          <div className="dcp-heading">
            <p className="dcp-micro" id="dcp-heading">
              Continue
            </p>
            <p className="dcp-note">
              Your balance read and ledger stay available here. Move funds or review past
              transfers from this instrument.
            </p>
          </div>

          <div className="dcp-actions">
            {DESTINATIONS.map((destination) => (
              <a
                key={destination.href}
                className="dcp-control"
                href={destination.href}
              >
                <span className="dcp-control-label">
                  <span className="dcp-control-title">{destination.title}</span>
                  <span className="dcp-control-sub">{destination.sub}</span>
                </span>
                <span className="dcp-control-route">{destination.route}</span>
                <span className="dcp-control-arrow" aria-hidden="true">
                  {destination.arrow}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashboardContinuePanel;